<template>
  <section class="scene">
    <!-- people -->
    <img alt="Duck" src="@/assets/images/people/duck.png" class="person person--duck">
    <img alt="Bunny" src="@/assets/images/people/bunny.png" class="person person--bunny">
    <!-- content -->
    <!--
    <div class="content content--top">
      <div class="container">
        <h2 class="title">
          Discover the world
        </h2>
      </div>
    </div>
    -->
  </section>
</template>

<script>
export default {
  name: 'VillageWorld'
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

.person--duck {
  display: none;
  bottom: 80px;
  left: 10%;

  @include breakpoint(sm) {
    display: block;
  }
}
.person--bunny {
  bottom: 20px;
  left: 40%;

  @include breakpoint(sm) {
    left: 70%;
  }
}
</style>
